/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AdminStockAdjustLocationMoveResVo
 */
export interface AdminStockAdjustLocationMoveResVo {
    /**
     * 来源箱ID
     * @type {number}
     * @memberof AdminStockAdjustLocationMoveResVo
     */
    sourceBoxId?: number;
    /**
     * 目标箱ID
     * @type {number}
     * @memberof AdminStockAdjustLocationMoveResVo
     */
    targetBoxId?: number;
    /**
     * 目标箱唛/箱号
     * @type {string}
     * @memberof AdminStockAdjustLocationMoveResVo
     */
    targetMarkNo?: string;
    /**
     * 本次移箱数量
     * @type {number}
     * @memberof AdminStockAdjustLocationMoveResVo
     */
    movedQuantity?: number;
}

/**
 * Check if a given object implements the AdminStockAdjustLocationMoveResVo interface.
 */
export function instanceOfAdminStockAdjustLocationMoveResVo(value: object): value is AdminStockAdjustLocationMoveResVo {
    return true;
}

export function AdminStockAdjustLocationMoveResVoFromJSON(json: any): AdminStockAdjustLocationMoveResVo {
    return AdminStockAdjustLocationMoveResVoFromJSONTyped(json, false);
}

export function AdminStockAdjustLocationMoveResVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): AdminStockAdjustLocationMoveResVo {
    if (json == null) {
        return json;
    }
    return {
        
        'sourceBoxId': json['sourceBoxId'] == null ? undefined : json['sourceBoxId'],
        'targetBoxId': json['targetBoxId'] == null ? undefined : json['targetBoxId'],
        'targetMarkNo': json['targetMarkNo'] == null ? undefined : json['targetMarkNo'],
        'movedQuantity': json['movedQuantity'] == null ? undefined : json['movedQuantity'],
    };
}

export function AdminStockAdjustLocationMoveResVoToJSON(json: any): AdminStockAdjustLocationMoveResVo {
    return AdminStockAdjustLocationMoveResVoToJSONTyped(json, false);
}

export function AdminStockAdjustLocationMoveResVoToJSONTyped(value?: AdminStockAdjustLocationMoveResVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'sourceBoxId': value['sourceBoxId'],
        'targetBoxId': value['targetBoxId'],
        'targetMarkNo': value['targetMarkNo'],
        'movedQuantity': value['movedQuantity'],
    };
}

